import './App.css';
import './components/ImageFitter.css';
import ImageFitter from './components/ImageFitter'
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Header from './components/Header';
import Footer from './components/Footer';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
}));


function App() {
  const classes = useStyles();
  let [fileInfo, setFilePath] = useState(null);
  let imageFitterComponent;
  let [fileInfoList, setFileInfoList] = useState([]);
  let [ratio, setRatio] = useState("");

  if (fileInfoList.length > 0) {
    imageFitterComponent = fileInfoList.map((fileInfo) => <ImageFitter key={fileInfo.path} fileInfo={fileInfo} ratio={ratio} />
    );
  }

  var loadFile = (event) => {
    let fileList = [];
    let _ = event.target.files;
    for (let i = 0; i < _.length; i++) {
      fileList.push(_[i]);
    }
    let _fileInfoList = []
    fileList.forEach(fileItem => {
      const url = URL.createObjectURL(fileItem);
      fileInfo = {}
      fileInfo['path'] = url;
      fileInfo['name'] = fileItem.name;
      _fileInfoList.push(fileInfo);
    });
    fileInfoList = _fileInfoList;
    loadImage('16x9');
    // console.log("from load file", fileInfoList);
  };

  var loadImage = async (ratio) => {
    // console.log("ratio", ratio);
    setRatio(ratio);
    await setFileInfoList(fileInfoList);
    // console.log("file info list", fileInfoList);

    let showImages = document.getElementById("showImages");
    showImages.scrollIntoView({ behavior: 'smooth' });
  }
  return (
    <div className="p-2 mx-8 flex flex-col justify-between h-screen">
      {/* <div className="p-2 mx-8"> */}
      <Header></Header>
      <div>
        <section className="text-gray-600 body-font">
          <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
            <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
              <img className="object-cover object-center rounded" alt="hero" src="images/img1.svg" />
            </div>
            <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Fit Images
                <br className="inline-block" />With Beautiful Blurred Border
              </h1>
              <p className="mb-8 leading-relaxed">Edit images to get blurred borders. Get an amazing creative look to share on any social media. No need to crop photos anymore for instagram or youtube.</p>
              <div className="flex flex-col space-y-4 justify-center">
                <input
                  accept="image/*"
                  className={classes.input}
                  id="contained-button-file"
                  multiple
                  type="file" accept="image/*"
                  name="image"
                  onChange={loadFile}
                />
                <label htmlFor="contained-button-file">
                  <Button variant="contained" color="secondary" style={{ backgroundColor: '#8b5cf6' }} component="span">
                    <div className="flex flex-row space-x-2 items-center">
                      <div>Select Images</div>
                      <CloudUploadOutlinedIcon></CloudUploadOutlinedIcon>
                    </div>
                  </Button>
                </label>
                <div className="space-x-2 flex flex-1">
                  <Tooltip title="Youtube" aria-label="Youtube">
                    <button className={(ratio === '16x9' ? 'bg-blue-500 text-white ' : ' text-blue-500 ') + 'border-2  border-blue-500 p-1  hover:bg-blue-500 hover:text-white rounded-md flex-1'} onClick={() => { loadImage("16x9") }} value="16x9">16x9</button>
                  </Tooltip>
                  <Tooltip title="Instagram Posts" aria-label="Instagram">
                    <button className={(ratio === '4x3' ? 'bg-blue-500 text-white ' : ' text-blue-500 ') + 'border-2  border-blue-500 p-1  hover:bg-blue-500 hover:text-white rounded-md flex-1'} onClick={() => { loadImage("4x3") }} value="4x3">4x3</button>
                  </Tooltip>
                  <Tooltip title="Whatsapp dp or Insta" aria-label="Dp">
                    <button className={(ratio === '1x1' ? 'bg-blue-500 text-white ' : ' text-blue-500 ') + 'border-2  border-blue-500 p-1  hover:bg-blue-500 hover:text-white rounded-md flex-1'} onClick={() => { loadImage("1x1") }} value="1x1">1x1</button>
                  </Tooltip>
                  <Tooltip title="Reels or Stories" aria-label="Reels">
                    <button className={(ratio === '9x16' ? 'bg-blue-500 text-white ' : ' text-blue-500 ') + 'border-2  border-blue-500 p-1  hover:bg-blue-500 hover:text-white rounded-md flex-1'} onClick={() => { loadImage("9x16") }} value="9x16">9x16</button>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div id="showImages" className="flex flex-wrap justify-center">
          {imageFitterComponent}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;